<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a><strong><em>D<span class="small">EDICATION</span></em></strong></p>
<p class="center"><em>To our daughters, Kindra and Kerith,<br/>who are coincidentally both back in school<br/>and rebooting their own lives.</em></p>
<p class="center"><em>May the world you inherit be as rich in wonder and<br/>opportunity as the world into which your parents were born.</em></p>
<p class="center"><em>Thank you both for being such wonderful, caring,<br/>and honorable human beings, so dedicated to<br/>healing the world one person at a time.</em><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?855659e8